<template>
  <div :class="mainWrapperClass">
    <div :class="$modal.modalContent">
      <form @submit.prevent="formAction">
        <v-flex>
          <p :class="$modal.modalText">
            If you’ve saved your number with our kiosk before,
            or would like to create an account, enter your phone number below:
          </p>
        </v-flex>
        <v-flex :class="$modal.modalInput">
          <InputField :class="{[$modal.errorField] : $v.phone.$error }"
                      :return-masked-value="false"
                      v-model="$v.phone.$model"
                      mask="(###) ### - ####"
                      placeholder="(xxx) xxx - xxxx"
                      label="Phone Number*"
                      type="tel"/>
          <p v-if="$v.phone.$error"
             :class="$modal.errorMessage">
            Phone is required
          </p>
          <p v-if="errors"
             :class="$modal.errorMessage">
            {{ errors }}
          </p>
        </v-flex>
        <v-flex>
          <p :class="$modal.legalText">
            The phone number provided to burger boss
            will only be used for account identification.
            It will not be shared in any way shape
            or form with any 3rd party companies
          </p>
        </v-flex>
        <MobileButton v-if="isMobilePlatform"
                      :class="$modal.mobileBtn"
                      :disabled="pending"
                      @click="formAction">
          Submit
        </MobileButton>
        <v-flex v-else
                :class="$modal.modalButtons">
          <BaseButton :button-style="'Main'"
                      :disabled="pending"
                      :class="$modal.submitBtn"
                      @click="formAction">Submit</BaseButton>
          <button :class="$modal.cancelBtn"
                  type="button"
                  @click="close()">Cancel</button>
        </v-flex>
      </form>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Action, Getter } from 'vuex-class';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import BaseButton from '@/components/BaseButton';
import authMixins from '@/apps/auth/mixins';
import { AUTH_CHECK_PHONE } from '@/apps/auth/store/types';
import InputField from '@/components/InputField';
import MobileButton from '@/apps/mobile/components/MobileButton';

/**
 * Form to check if phone number exists. On success will store pone data in
 * vuex store for further use.
 *
 * Data:
 *
 * phone - Stores phone number from input.
 */
@Component({
  name:       'SignIn',
  components: {
    BaseButton,
    InputField,
    MobileButton,
  },
  mixins: [
    authMixins.AuthorizationMixin,
  ],
  validations: {
    phone: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(14),
    },
  },
  props: {
    checkoutAfterLogin: {
      type:    Boolean,
      default: false,
    },
  },
})
export default class SignIn extends Vue {
  phone = '';
  @Getter isMobilePlatform;
  @Getter pending;
  @Action(AUTH_CHECK_PHONE) vuexAction;

  get mainWrapperClass() {
    const mobileWrapperClass = this.isMobilePlatform ? this.$modal.modalMobile : '';

    return [ this.$modal.modalContentContainer, mobileWrapperClass ];
  }

  /**
   * Pass phone number in api call.
   * If the number is written without a code straniu add +1
   *
   * @returns {{phone: string}}
   */
  getData() {
    if (this.phone.startsWith('+')) {
      return { phone: this.phone };
    }

    return { phone: `+1${this.phone}` };
  }

  /**
   * Inform parent that the phone is checked, and return the result.
   * @param profileExists - The status of existence of the account
   */
  handleSuccess(profileExists) {
    this.$emit('phoneChecked', { profileExists });

    if (this.isMobilePlatform && profileExists) {
      this.$router.push({ name: 'login', query: { checkoutAfterLogin: this.checkoutAfterLogin } });
    } else if (this.isMobilePlatform) {
      this.$router.push({ name: 'create-account', query: { checkoutAfterLogin: this.checkoutAfterLogin } });
    }
  }
}
</script>

<style src="@/style/modals.scss" lang="scss" module="$modal"></style>



// WEBPACK FOOTER //
// src/apps/auth/components/SignIn.vue